export var ModalStyle;

(function (ModalStyle) {
  ModalStyle["Default"] = "default";
  ModalStyle["BottomSheet"] = "bottom-sheet";
})(ModalStyle || (ModalStyle = {}));